import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Helmet } from 'react-helmet';

import Plate from 'components/UI/Plate/Plate';
import Button from 'components/UI/Button/Button';
import { TextInput } from 'components/UI/TextInput/TextInput';

import { ApiError } from '../../client.js';
import { getCookie, setCookie } from 'utils/cookie.js';

import AppStore from 'AppStore.js';
import popupStore from 'components/Popup/PopupStore.js';
import messageBoxStore from 'MessageBox/MessageBoxStore';

import client from 'client';

import './SignIn.scss';

export const SignIn = observer(() => {

  const navigate = useNavigate();
  const redirectUrl = getCookie('redirect_url');

  const [isBusy, setIsBusy] = useState(false);

  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  async function onSubmit() {
    if (isBusy)
      return;

    if (!login)
      return messageBoxStore.showError('Введите email.');
    if (!password)
      return messageBoxStore.showError('Введите пароль.');

    let token = '';

    setIsBusy(true);
    try {
      token = await client.signin(login, password);
      AppStore.setToken(token);
      await AppStore.updateProfile();
      if (!AppStore.profile?.agree) {
        popupStore.open('accept-rules');
      }
    } catch (e) {
      if (e instanceof ApiError) {
        messageBoxStore.showError(e.message);
        return;
      }
      throw e;
    } finally {
      setIsBusy(false);
    }

    AppStore.setToken(token);

    if (redirectUrl) {
      setCookie('redirect_url', '', { expires: -1 });
      navigate(redirectUrl);
    } else {
      navigate('/');
    }
  }

  return (
    <div className='signin'>
      <Helmet>
        <title>Вход в сервис по накрутке — Boostclick</title>
        <meta name="description" content="Зайти в личный кабинет в сервис Boostclick" />
        <meta name="robots" content="noindex" />
      </Helmet>

      <form className="signin__form" onSubmit={e => { e.preventDefault(); onSubmit() }}>
        <Plate className='signin__plate'>
          <h1 className='signin__title'>Вход</h1>

          <TextInput classes={["signin__input"]} placeholder='Email' type='email' onChange={e => setLogin(e.target.value)} />
          <TextInput classes={["signin__input"]} placeholder='Пароль' type='password' onChange={e => setPassword(e.target.value)} />

          <Button title='Войти в мой аккаунт' />

          <div className='signin__links-container'>
            <Link className='signin__link' to='/signup'>Регистрация</Link>
            <Link className='signin__link' to='/restore'>Забыли пароль?</Link>
          </div>
        </Plate>
      </form>
    </div>
  );
});
